import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';

class SearchTableComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchText: '',
    };
    this.typingTimer = null;
  }

  componentDidMount() {
    if (this.props.searchText != null) {
      this.setState({ searchText: this.props.searchText });
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.searchText !== prevProps.searchText) {
      this.setState({ searchText: this.props.searchText });
    }
  }

  search = (value) => {
    clearTimeout(this.typingTimer);
    this.setState({ searchText: value });

    if (value && value.length <= 2) {
      return;
    }

    this.typingTimer = setTimeout(() => {
      this.props.search(value.trim());
    }, 500);
  }

  checkIfShouldAutofocus = (input) => {
    if (this.props.disableAutofocus) {
      return false
    } else {
      return input && input.focus()
    }
  }

  render() {
    const { id, colSize } = this.props;

    return (
      <div className={`table-search-control col-xs-12 ${colSize ? `col-sm-${colSize}` : "col-sm-6"} search-div-${id}`}>
        <FontAwesomeIcon size="lg" icon={faSearch} />
        <FormattedMessage id="components.layout.paginator.searchTable.searchText">{
          placeHolder =>
            <input
              id={`search-input-table-${id}`}
              className="form-control form-control-sm"
              type="text"
              maxLength="150"
              placeholder={placeHolder}
              disabled={this.props.loading > 0}
              aria-label="Search"
              value={this.state.searchText}
              onChange={e => this.search( e.target.value )}
              ref={input => this.checkIfShouldAutofocus(input)}
            />
        }
        </FormattedMessage>
      </div>
    );
  }
}

SearchTableComponent.defaultProps = {
  search: () => { }
};

const mapStateToProps = state => ({
  loading: state.loading.pendingRequests
});

const SearchTable = connect(mapStateToProps)(SearchTableComponent);

export { SearchTableComponent, SearchTable };
